import { motion } from "framer-motion";
import { ArrowRight, Check, PartyPopper, Send } from "lucide-react";
import { Avatar } from "@/components/Avatar";
import { formateazaRON } from "@/lib/settlement";

// Tab-ul „Decontare": transferurile minime necesare ca toată lumea să fie chit.
export function SettlementTab({ decontari, numeMembru, onMarkPaid, onExportWhatsApp }) {
  if (decontari.length === 0) {
    return (
      <div className="flex flex-col items-center text-center mt-16">
        <div className="h-16 w-16 rounded-3xl bg-emerald-100 flex items-center justify-center mb-4">
          <PartyPopper className="h-8 w-8 text-emerald-600" strokeWidth={2.5} />
        </div>
        <p className="font-heading font-bold text-slate-800">Toată lumea e chit!</p>
        <p className="text-sm text-slate-500 mt-1">Nimeni nu mai datorează nimic.</p>
      </div>
    );
  }
  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between px-1">
        <p className="text-sm text-slate-500">
          {decontari.length} transfer{decontari.length > 1 ? "uri" : ""} ca toată lumea să fie chit:
        </p>
        <button
          data-testid="export-whatsapp-btn"
          onClick={onExportWhatsApp}
          className="shrink-0 flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-emerald-600 text-white text-xs font-semibold hover:bg-emerald-700 active:scale-95 transition-transform"
        >
          <Send className="h-3.5 w-3.5" strokeWidth={2.5} />
          Trimite
        </button>
      </div>
      {decontari.map((t, i) => (
        <motion.div
          key={i}
          initial={{ opacity: 0, x: -8 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: i * 0.05 }}
          data-testid={`settlement-item-${i}`}
          className="bg-white rounded-2xl border border-slate-100 shadow-sm p-4"
        >
          <div className="flex items-center gap-3">
            <Avatar name={numeMembru(t.deLa)} size="sm" />
            <ArrowRight className="h-4 w-4 text-slate-300 shrink-0" strokeWidth={2.5} />
            <Avatar name={numeMembru(t.catre)} size="sm" />
            <p className="flex-1 text-sm text-slate-700">
              <span className="font-bold">{numeMembru(t.deLa)}</span> îi dă lui{" "}
              <span className="font-bold">{numeMembru(t.catre)}</span>
            </p>
            <p className="font-heading font-extrabold text-emerald-600 shrink-0">{formateazaRON(t.suma)}</p>
          </div>
          <button
            data-testid={`mark-paid-btn-${i}`}
            onClick={() => onMarkPaid(t)}
            className="mt-3 w-full h-10 rounded-xl bg-emerald-50 text-emerald-700 text-sm font-semibold flex items-center justify-center gap-1.5 hover:bg-emerald-100 transition-colors"
          >
            <Check className="h-4 w-4" strokeWidth={2.5} />
            Marchează plătit
          </button>
        </motion.div>
      ))}
    </div>
  );
}
